import { render, staticRenderFns } from "./SliderSection.vue?vue&type=template&id=e5099762&scoped=true&"
import script from "./SliderSection.vue?vue&type=script&lang=js&"
export * from "./SliderSection.vue?vue&type=script&lang=js&"
import style0 from "./SliderSection.vue?vue&type=style&index=0&id=e5099762&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5099762",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SwiperCarrousel: require('/codebuild/output/src3208117147/src/studio-frank/components/SwiperCarrousel.vue').default})
